var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-loading"},[_c('div',{staticClass:"wrap"},[_c('img',{attrs:{"width":"24","height":"24","src":require("./loading.gif")}}),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }